/** 阿里云风控初始化 */
// AWSC.use('uab', function (state, uab) {
//   if (state === 'loaded') {
//     window.aliUabModule = uab
//   }
// })
// AWSC.use('um', function (state, um) {
//   if (state === 'loaded') {
//     um.init(
//       {
//         appName: 'saf-aliyun-com',
//       },
//       function (initState, result) {
//         if (initState === 'success') {
//           window.aliWebUmidToken = result.tn
//         }
//       }
//     )
//   }
// })

/** 网易易盾初始化 */
window.wangYiYD = null
// 只需初始化一次
initWatchman({
  productNumber: process.env.VUE_APP_WANGYI_PRODUCT_NUMBER,
  onload: function (instance) {
    wangYiYD = instance
  },
})
